/*
  Project: Elefint Redesign
  Author: Xfive
 */

import smoothscroll from 'smoothscroll-polyfill';
import objectFit from './polyfills/object-fit';
import header from './modules/header';
import works from './modules/works';
import posts from './modules/posts';
import slider from './modules/slider';
import testimonials from './modules/testimonials';
import columns from './modules/columns';
import social from './modules/social';
import carousel from './modules/carousel';

// Polyfills
objectFit();
smoothscroll.polyfill();

// Code
header();
slider();
testimonials();
columns();
works();
posts();
social();
carousel();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/elefint-redesign-chisel/src/scripts/app.js